import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';
import { ReferenceItem } from '../model/reference-item.model';

/**
 * Service to get and save reference items data.
 */
@Injectable()
export class ReferenceItemService {
    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all reference items
     */
    public getIndex(queryParams?: string[]): Observable<ReferenceItem[]> {
        const apiRequestUrl: string = this.getApiUrl(null, queryParams);

        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const referenceItems: ReferenceItem[] = [];
                const bodyData: any = response.data || [];
                for (const referenceItem of bodyData) {
                    referenceItems.push((new ReferenceItem()).deserialize(referenceItem));
                }
                return referenceItems;
            }));
    }

    /**
     * Get a single reference item's data
     */
    public get(referenceItemId: string): Observable<ReferenceItem> {
        const apiRequestUrl: string = this.getApiUrl(referenceItemId);

        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => (new ReferenceItem().deserialize(response))));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(referenceItemId?: string, queryParams?: string[]): string {
        let url: string = `${this.http.configService.getApiBaseUrl()}/reference-items/`;

        if (referenceItemId) {
            url += referenceItemId;
        }

        url += this.http.getQueryParameters(null, queryParams);

        return url;
    }
}
